import { gql, QueryHookOptions } from '@apollo/client';
import { GraphQLCampaign } from 'modules/campaignIndex/domainTypes';
import { GraphQLResponsePaginationInfo } from 'modules/graphql';
import {
  DEFAULT_PAGINATION as pagination,
  DEFAULT_SORT_BY as sortBy,
  DEFAULT_SORT_DIRECTION as sortDirection,
} from 'modules/quickActionsMenu/constants';
import { useGraphql } from 'utils/hooks/useGraphql';
import { GraphQLVariables } from '../types';

export const getQuickActionsCampaigns = gql`
  query getQickActionsCampaigns($pagination: Pagination, $search: String, $sort: Sort) {
    campaigns(pagination: $pagination, search: $search, sort: $sort) {
      info {
        count
        limit
        offset
        page
      }
      results {
        id
        name
        messageMedium
        campaignState
        templateId
      }
    }
  }
`;

type QueryCampaignsResponse = {
  campaigns: {
    info: GraphQLResponsePaginationInfo;
    results: Pick<
      GraphQLCampaign,
      'id' | 'name' | 'messageMedium' | 'campaignState' | 'templateId'
    >[];
  };
};

export const useQueryCampaigns = (
  search: string,
  options?: QueryHookOptions<QueryCampaignsResponse, GraphQLVariables>,
) =>
  useGraphql<QueryCampaignsResponse>(getQuickActionsCampaigns, {
    ...options,
    variables: {
      search,
      sort: { sortBy, sortDirection },
      pagination,
    },
  });
